// extracted by mini-css-extract-plugin
module.exports = {"contentEditable":"index_contentEditable__2FJ4D"};